import React, { useState } from 'react';
import '../App.css';
import axios from "axios";

//import axios from "axios";
import { Dropdown, Modal } from 'react-bootstrap';
import Classe_Form_Base from "./Classe_form_base";
import { AiOutlineMenuFold } from 'react-icons/ai';
import Carica_alunni_XLS from "./Classe_x3_carica_alunni";
//import * as XLSX from "xlsx";
import Aggiungi_documentazione_attore from "../Funzioni_comuni_pdf_upload.jsx"; 


const Nuova_Classe_Edit = (props) => {

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [end_Date, set_End_Date] = useState(new Date());
    const [items, setItems] = useState([]);


    function cancellazione_classe() {
        //        axios.post('http://localhost:3001/create', newNote)
        console.log(props.classe._id)
           {/* idroslab controllare che non venga cancellato veramente*/}
     
        axios.delete('/classi/cancella_classe/' + props.classe._id)
            .then((res) => {
                console.log(res.data)

            }).catch((error) => {
                console.log(error)
            });
     
        props.SET_variab_aggiorna(current => !current)
    }

    return (
        <div class="d-flex flex-row-reverse">
            <Dropdown>
                <Dropdown.Toggle variant="Light" id="dropdown-basic">
                    Menu  <AiOutlineMenuFold />
                </Dropdown.Toggle>

                <Dropdown.Menu>
                    <div class="dropdown-divider"></div>
                    <Dropdown.Item onClick={handleShow} >Edit Classe</Dropdown.Item>
                    <Dropdown.Item onClick={cancellazione_classe} >Cancella Classe</Dropdown.Item>
                    <Carica_alunni_XLS  classe= {props.classe}/>

                    <Aggiungi_documentazione_attore attore_tipo ={'classi'} tipologia_documento={'File_word_rischio_basso'} tutor={props.tutor} attore={props.classe} SET_variab_aggiorna={props.SET_variab_aggiorna} />
                    <Aggiungi_documentazione_attore attore_tipo ={'classi'} tipologia_documento={'File_word_rischio_medio'} tutor={props.tutor} attore={props.classe} SET_variab_aggiorna={props.SET_variab_aggiorna} />
                    <Aggiungi_documentazione_attore attore_tipo ={'classi'} tipologia_documento={'File_word_rischio_alto'}  tutor={props.tutor} attore={props.classe} SET_variab_aggiorna={props.SET_variab_aggiorna} />
               
                </Dropdown.Menu>
            </Dropdown>

            <Modal
                show={show}
                size="lg"
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Dialog>
                    <Modal.Title id="example-custom-modal-styling-title">
                    </Modal.Title>
                    <Modal.Body>
                        <Classe_Form_Base id={props.classe._id} setShow={setShow} />
                    </Modal.Body>
                </Modal.Dialog>
            </Modal>
        </div>
    )
}

export default Nuova_Classe_Edit;
